<script lang="ts" setup>
// ================================
// IMPORTS
// ================================

// ================================
// TYPES & INTERFACES
// ================================

export type BaseSummaryLine = {
    label: string
    value: string
}

type Props = {
    /** Lignes à afficher (label / value en texte seul) */
    lines: BaseSummaryLine[]
    /** Style de l’encart */
    variant?: "grey" | "default"
}

// ================================
// PROPS & EMITS
// ================================

withDefaults(defineProps<Props>(), {
    variant: "default",
})
</script>

<template>
    <div
        class="base-summary flex flex-col gap-2 rounded-md p-4"
        :class="{
            'bg-gray-100 border border-gray-200': variant === 'grey',
            'bg-white border border-gray-200': variant === 'default',
        }"
    >
        <div
            v-for="(line, index) in lines"
            :key="index"
            class="base-summary__row flex flex-col gap-0.5 sm:flex-row sm:gap-2"
        >
            <span class="base-summary__label text-sm font-medium text-gray-600">
                {{ line.label }}
            </span>
            <span class="base-summary__value text-sm text-gray-900">
                {{ line.value }}
            </span>
        </div>
    </div>
</template>
